export const environment = {
  production: false,
  isUat: true,
  baseURL:{
    urlType: 'uat'
  },

  dpatAPIUrl: `https://dpatinside-api-vulture.upscapital.com`,
//  walletAPIUrl:`https://ib-wallet-euat-api.azurewebsites.net`,
//  walletAPPUrl:`https://ib-wallet-euat-app.azurewebsites.net`,

walletAPIUrl:`https://wallet-svcs-vulture.ups.com`,
walletAPPUrl:`https://wallet-vulture.ups.com`,

  loginUrl: 'https://online-vulture.upscapital.com/login',
  createAccount: 'https://online-vulture.upscapital.com/create-account',

  ppiLoginUrl: 'https://web.parcelpro.com/login',
  ppiBillLink:'https://web.parcelpro.com/billing-history',
  authorizeNetDomain:'https://test.authorize.net/',
  
  get baseApiUrl() {
    return `${this.dpatAPIUrl}/api/`;
  },
  get walletbaseApiUrl() {
    return `${this.walletAPIUrl}/api/`;
  },

  get walletbaseApiUrlNextGen() {
      return `${this.walletAPIUrl}/api/`; // Points to Azure
    },

  auth0: { 
        domain: 'ptt.id.ups.com', 
        clientId: 'B1fiEkGJFyJRRhlI23PsvZEIpIw4Y5wq'
  },
  tealium: {
    profile: 'maestro',
    env: 'qa'
  },
  auth0SSO: {
    domain: 'staging.id.upscapital.com', 
    clientId: 'Ie7RrJBDrJtFCJyDUgepZhBOBCFzaalm'
  },

  apiUrls: {
   // session: "Authentication/ONLValidateWalletSession?sessionId=",
    sessionjwt: "Authentication/ONLValidateWalletSessionJWT",
    sessionjwtPPI: "Authentication/PPIValidateWalletSession",
    profile: 'DigitalWalletAPI',

    addCreditCard: 'ParcelPro/DWAddCreditCard',
    editCreditCard: 'ParcelPro/DWEditCreditCard',
    listCreditCard: 'ParcelPro/DWListCreditCards',
    deleteCreditCard: 'ParcelPro/DWDeleteCreditCard',
    notifyCreditCardAdd: 'ParcelPro/DWNotifyCreditCardAdd',
    notifyCreditCardEdit: 'ParcelPro/DWNotifyCreditCardEdit',  
    dwGetPPIAutoRedeem: 'DigitalWalletAPI/DWGetPPIAutoRedeem',
    dwSetPPIAutoRedeem: 'DigitalWalletAPI/DWSetPPIAutoRedeem',

    DWGetNewTokenPage: 'DigitalWalletAPI/DWGetNewTokenPage',
    DWGetEditTokenPage: 'DigitalWalletAPI/DWGetEditTokenPage',
    DWNotifyTokenAdd: 'DigitalWalletAPI/DWNotifyTokenAdd',
    DWNotifyTokenEdit: 'DigitalWalletAPI/DWNotifyTokenEdit',
    DWGetPaymentMethod: 'DigitalWalletAPI/dwgetpaymentmethods',
    DWDeletePaymentMethod: 'DigitalWalletAPI/DWDeletePaymentMethod',
    DWSetAutoRedeem: 'DigitalWalletAPI/DWSetAutoRedeem',

    DWSetDefaultPaymentUrl: 'DigitalWalletAPI/DWSetDefaultPaymentMethod',
    DWSetAutoPay: 'DigitalWalletAPI/DWSetAutoPay',

    ppGetTokenInfo: 'DigitalWalletAPI/DWGetTokenInfo',
    ppGetPayoutTokens: 'DigitalWalletAPI/DWGetPayoutTokens',


    walletSummary: 'DigitalWalletAPI/dwwalletsummary',
    ppiWalletSummary: 'DigitalWalletAPI/ppiwalletsummary',
    walletSetup: 'DigitalWallet/DWWalletSetup',
    walletSetupNextGen: 'DigitalWalletAPI/DWWalletSetup',

    transactionHistory: 'DigitalWalletAPI/dwgettransactionhistory',
    sourceIdentifier: 'DigitalWalletAPI/dwgetsourceidentifierdetails',
    invoiceDetails: 'DigitalWalletAPI/dwgetinvoicedetails',

    getAutoPaySequence: 'DigitalWalletAPI/dwgetautopaysequence',
    setAutoPay: 'DigitalWallet/DWSetAutoPay',

    redeemEarn: 'DigitalWalletAPI/redeemrewards',
    cashTransactionApiUrl: "DigitalWalletAPI/cashtransaction",
    invoicepaymentApiUrl: "DigitalWallet/DWMakeInvoicePayment",
    ppiinvoicepaymentApiUrl: "DigitalWalletAPI/DWMakeInvoicePayment",
    
    startWalletSession: 'Authentication/DWStartWalletSession',
    ppiStartWalletSession: 'Authentication/PPIStartWalletSession',

    dwTokenInfo: 'DigitalWallet/DWGetTokenInfo',
    setdefaultpaymentUrl: 'DigitalWallet/DWSetDefaultPaymentMethod',
    deletepaymentUrl: 'DigitalWallet/DWDeletePaymentMethod',

    dwPayoutTokenInfo:'DigitalWalletPayee/DWGetPayoutTokens',
    dwDeletePayoutToken:'DigitalWalletPayee/DWDeletePayoutToken',
    initiateCashTransfer: 'DigitalWalletAPI/dwinitiatecashtransfer',

    appNotification: 'DigitalWalletAPI/dwgetwalletnotificationforapp',
    setAppNotification: 'DigitalWalletAPI/dwsetwalletnotificationforapp',

    authTargetApiUrl: 'DigitalWallet/Auth0/DWAuthorizeUPSdotcomSession',
    dwUpdateWalletStatus: 'DigitalWalletAPI/DWUpdateWalletStatus',

    dwGetMaritzUrl: 'DigitalWalletAPI/DWGetMaritzUrl',
    dwGetInvoiceDetails: 'DigitalWalletAPI/DWGetInvoiceDetails',
    dwMakeInvoiceDetails: 'DigitalWalletAPI/DWMakeInvoiceDetails'

  }
};
  